// Emitted after the WebSocket restores its connection and subscriptions.
export const GRAPHQL_RECONNECTED = 'graphql:reconnected';
